<div class="localization-main">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    @if (canManageDisplayPreferences) {
      <li [ngbNavItem]="LocalizationTab.Formats">
        <a ngbNavLink>
          <span class="ml-1">{{ 'Settings::Localization:Tabs:Formats' | abpLocalization }}</span>
        </a>
        <ng-template ngbNavContent>
          <app-localization-settings [sections]="['formats']" />
        </ng-template>
      </li>
      <li [ngbNavItem]="LocalizationTab.Language">
        <a ngbNavLink>
          <span class="ml-1">{{ 'Settings::Localization:Tabs:Language' | abpLocalization }}</span>
        </a>
        <ng-template ngbNavContent>
          <app-localization-settings [sections]="['language']" />
        </ng-template>
      </li>
    }
    @if (canViewHolidays) {
      <li [ngbNavItem]="LocalizationTab.Holidays">
        <a ngbNavLink>
          <span class="ml-1">{{ 'Settings::Localization:Tabs:Holidays' | abpLocalization }}</span>
        </a>
        <ng-template ngbNavContent>
          <app-holiday-settings />
        </ng-template>
      </li>
    }
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>
